import { render, staticRenderFns } from "./miga.vue?vue&type=template&id=67f68014&scoped=true"
import script from "./miga.vue?vue&type=script&lang=js"
export * from "./miga.vue?vue&type=script&lang=js"
import style0 from "./miga.vue?vue&type=style&index=0&id=67f68014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f68014",
  null
  
)

export default component.exports